import { Button } from "@/shared/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface FileNavigationHeaderProps {
  fileName: string;
  canNavigatePrev: boolean;
  canNavigateNext: boolean;
  onNavigate: (direction: "prev" | "next") => void;
}

export function FileNavigationHeader({
  fileName,
  canNavigatePrev,
  canNavigateNext,
  onNavigate,
}: FileNavigationHeaderProps) {
  return (
    <div className="flex items-center justify-between border-b border-grid-200 px-6 py-3">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onNavigate("prev")}
        disabled={!canNavigatePrev}
        aria-label="Previous file"
      >
        <ChevronLeft className="h-5 w-5" />
      </Button>
      <p className="flex-1 truncate text-center text-sm font-medium text-ink-900">
        {fileName}
      </p>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onNavigate("next")}
        disabled={!canNavigateNext}
        aria-label="Next file"
      >
        <ChevronRight className="h-5 w-5" />
      </Button>
    </div>
  );
}

